import {useEffect, useState} from 'react'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import ProspectSegmentation from './ProspectSegmentation'
import layoutConfig from '../../configs/layoutConfig.json'
import {useDispatch, useSelector} from 'react-redux'
import AllConstituents from './ProspectSegmentation/SavedProspects/AllConstituents/AllConstituentsIndex'
import AddToSavedProspects from './ProspectSegmentation/AllProspects/AddToSavedProspects/AddToSavedProspectsIndex'
import AskGivePrism from './AskGivePrism'
import {setRefData, setRefDataLoading} from '../../store/opportunityBank/opportunityBankSlice'
import {
  setAppliedInterestTags,
  setCategorisedInterestTagRefData,
  setCategorisedInterestTagRefDataError,
  setCategorisedInterestTagRefDataLoading
} from '../../store/askGivePrism/categorizedInterestTagSlice'
import useOpportunitiesRefData from '../../api/getOpportunitiesRefData'
import useCategorizedInterestTagsRefData from '../../api/getCategorizedInterestTags'
import {StyledActionAddButton, StyledActionResetButton, StyledSwitchButton} from './AskGivePrism/Styles'
import {
  setButtonViewName,
  setCurrentSelectedFilter,
  setFilters,
  setSwitchFilters
} from '../../store/askGivePrism/askGivePrismSlice'
import {StyledActionBox, StyledToolBar} from '../Common/Styles'
import {
  setChatbotData,
  setInterestTagId,
  setLLMLoader,
  setMatchedProspectId,
  setMatchedProspectList,
  setMessage
} from '../../store/askGivePrism/chatbot/chatbotStreamSlice'
import {getProspectsPageNumber} from '../../store/pagination/pageNumberSlice'
import {selectedTab} from '../../store/prospectSegment/selectedProspectsTab/selectedProspectsTabSlice'
import {
  getAllProspectsData,
  setSortColumn,
  setSortConfig,
  setSortDirection
} from '../../store/prospectSegment/allProspectsData/allProspectsDataSlice'
import useSessionManager from '../../hooks/useSessionManager'
import CustomDialog from '../Common/CustomDialog'
import {StyledTitleContainer} from '../Common/ProfileCircle/ProfileCircleStyles'
import {constituentIdList} from '../../store/prospectSegment/savedProspectsList/saveProspectsListSlice'

const getComponent = (key) => {
  const items = [
    {key: 'askGivePrism', content: AskGivePrism},
    {key: 'prospectSegmentation', content: ProspectSegmentation},
    {key: 'openSavedList', content: AllConstituents},
    {key: 'addToSavedList', content: AddToSavedProspects}
  ]
  return items.find((item) => item.key === key).content
}
const Campaigns = () => {
  const dispatch = useDispatch()
  const selectedView = useSelector((state) => state.campaignView.defaultValue)
  const storeRefData = useSelector((state) => state.opportunityBank.refData)
  const categorisedInterestTagRefData = useSelector(
    (state) => state.categorizedInterestTag.categorisedInterestTagRefData
  )
  const [getOpportunitiesRefData, {refData}] = useOpportunitiesRefData()
  const [getCategorizedInterestTagsRefData, {interestRefData, interestRefDataError}] =
    useCategorizedInterestTagsRefData()
  const view = layoutConfig[selectedView].components

  const switchFilters = useSelector((state) => state.askGivePrism.switchFilters)
  const buttonViewName = useSelector((state) => state.askGivePrism.buttonViewName)
  const askGivePrismFilters = useSelector((state) => state.askGivePrism.filters)

  const llmLoader = useSelector((state) => state.chatBotSlice.llmLoader)
  const sessionId = useSelector((state) => state.chatBotSlice.sessionId)

  const superUser = useSelector((state) => state.superUserTenantSlice.isSuperUser)
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)

  const appliedInterestTags = useSelector((state) => state.categorizedInterestTag.appliedInterestTags)
  const currentSelectedFilter = useSelector((state) => state.askGivePrism.currentSelectedFilter)

  const chatbotData = useSelector((state) => state.chatBotSlice.chatbotData)
  const mainPromptMessage = useSelector((state) => state.chatBotSlice.message)

  const constituentsList = useSelector((state) => state.saveProspectList.value)
  const [openDialog, setOpenDialog] = useState(false)

  const {deleteSession} = useSessionManager()

  useEffect(() => {
    dispatch(setButtonViewName(buttonViewName ?? 'Switch to manual view'))
  }, [buttonViewName, dispatch])

  useEffect(() => {
    if (superUser && !azureRole) {
      return
    }
    if (storeRefData === null || storeRefData === undefined) {
      dispatch(setRefDataLoading(true))
      getOpportunitiesRefData()
    }
  }, [getOpportunitiesRefData, storeRefData, dispatch, azureRole, superUser])

  useEffect(() => {
    if (categorisedInterestTagRefData === null || categorisedInterestTagRefData === undefined) {
      dispatch(setCategorisedInterestTagRefDataLoading(true))
      dispatch(setCategorisedInterestTagRefDataError(false))
      getCategorizedInterestTagsRefData()
    }
  }, [getCategorizedInterestTagsRefData, categorisedInterestTagRefData, dispatch])

  useEffect(() => {
    if (refData?.filterValues) {
      dispatch(setRefData(refData.filterValues))
      dispatch(setRefDataLoading(false))
    }
  }, [refData, dispatch])

  useEffect(() => {
    if (interestRefData?.categoryTags) {
      dispatch(setCategorisedInterestTagRefData(interestRefData.categoryTags))
      dispatch(setCategorisedInterestTagRefDataLoading(false))
      dispatch(setCategorisedInterestTagRefDataError(false))
    }
  }, [interestRefData, dispatch])

  useEffect(() => {
    if (interestRefDataError) {
      dispatch(setCategorisedInterestTagRefData(interestRefData?.categoryTags))
      dispatch(setCategorisedInterestTagRefDataLoading(false))
      dispatch(setCategorisedInterestTagRefDataError(true))
    }
  }, [interestRefData, interestRefDataError, dispatch])

  if (!layoutConfig?.[selectedView]) {
    console.error('Layout configuration or selected view is missing or invalid.')
    return null
  }

  const handleClose = () => {
    setOpenDialog(false)
  }

  const handleSwitchFilters = () => {
    if (
      Object.keys(askGivePrismFilters).length > 0 ||
      chatbotData.length > 0 ||
      mainPromptMessage ||
      appliedInterestTags.length > 0 ||
      Object.keys(currentSelectedFilter).length > 0
    ) {
      setOpenDialog(true)
    } else {
      handleConfirm()
    }
  }

  const handleConfirm = async () => {
    dispatch(setSwitchFilters(!switchFilters))
    if (switchFilters) {
      dispatch(setButtonViewName('Switch to manual view'))
      if (Object.keys(askGivePrismFilters).length > 0) {
        dispatch(setFilters({}))
        dispatch(getAllProspectsData([]))
        dispatch(getProspectsPageNumber(1))
        dispatch(selectedTab('allProspects'))
        dispatch(setMatchedProspectId([]))
        dispatch(setInterestTagId([]))
        dispatch(setMatchedProspectList([]))
        dispatch(setSortColumn(null))
        dispatch(setSortDirection('asc'))
        dispatch(setSortConfig({direction: 'asc', key: null}))
      }
      if (appliedInterestTags.length > 0 || Object.keys(currentSelectedFilter).length > 0) {
        dispatch(setCurrentSelectedFilter({}))
        dispatch(setAppliedInterestTags([]))
        dispatch(setSortColumn(null))
        dispatch(setSortDirection('asc'))
        dispatch(setSortConfig({direction: 'asc', key: null}))
      }
    } else {
      dispatch(setLLMLoader(false))
      deleteSession(sessionId)
      dispatch(setButtonViewName('Switch to chat view'))
      dispatch(setChatbotData([]))
      dispatch(setMessage(''))
      dispatch(setMatchedProspectId([]))
      dispatch(setInterestTagId([]))
      dispatch(setMatchedProspectList([]))
      dispatch(setSortColumn(null))
      dispatch(setSortDirection('asc'))
      dispatch(setSortConfig({direction: 'asc', key: null}))
    }
    if (constituentsList.length > 0 && openDialog) {
      dispatch(constituentIdList([]))
    }
    setOpenDialog(false)
  }

  return (
    <>
      <StyledToolBar />
      {selectedView === 'defaultView' && (
        <StyledSwitchButton onClick={handleSwitchFilters} disabled={llmLoader}>
          {buttonViewName}
        </StyledSwitchButton>
      )}
      <Grid container spacing={4}>
        {view.map((obj) => {
          const Component = getComponent(obj.key)
          return (
            <Grid
              sx={{'&.MuiGrid-item': {paddingTop: obj.key === 'askGivePrism' ? '15px' : '32px'}}}
              key={obj.key}
              item
              xs={obj.gridSize.xs}
              sm={obj.gridSize.sm}
              md={obj.gridSize.md}
              lg={obj.gridSize.lg}
              xl={obj.gridSize.xl}
            >
              <Paper id={obj.key + 'Container'}>
                <Component />
              </Paper>
            </Grid>
          )
        })}
      </Grid>

      <CustomDialog
        open={openDialog}
        maxWidth="xs"
        timelineDialog={true}
        showDivider={false}
        showCloseBtn={false}
        handleClose={handleClose}
        title={<StyledTitleContainer>{'Switching Views?'}</StyledTitleContainer>}
        content={
          switchFilters
            ? 'You will lose all your current manual filters applied to the table by switching. Are you sure you want to continue?'
            : 'You will lose everything related to your current chat session including chat history and any filtering done to the table by switching. Are you sure you want to continue?'
        }
        actions={
          <StyledActionBox>
            <StyledActionResetButton onClick={handleClose}>Cancel</StyledActionResetButton>
            <StyledActionAddButton onClick={handleConfirm}>Confirm</StyledActionAddButton>
          </StyledActionBox>
        }
      />
    </>
  )
}

export default Campaigns
